(function ($) {

    $('.review-form').each(function (){
        let form_container = $(this);
        let stars = form_container.find('.product-rating__icon'),
            rating_select = form_container.find('#rating');

        stars.on('click touchstart', function (e, i) {
            let current_star = $(this),
                index = current_star.index(),
                star_value = index + 1;

            stars.removeClass('product-rating__icon_active').each(function (i){
                if(i <= index){
                    stars.eq(i).addClass('product-rating__icon_active');
                }
            });

            rating_select.find('option').removeAttr('selected');
            rating_select.find('option[value="'+ star_value +'"]').attr('selected', 'selected');
            rating_select.val(star_value).trigger('change');
            // alert(star_value);
        });
    });
})(jQuery);
